import { render } from "./VvHeader.vue?vue&type=template&id=51cced41&scoped=true"
import script from "./VvHeader.vue?vue&type=script&lang=js"
export * from "./VvHeader.vue?vue&type=script&lang=js"

import "./VvHeader.vue?vue&type=style&index=0&id=51cced41&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51cced41"]])

export default __exports__